import { CdkScrollable } from '@angular/cdk/overlay';
import { Directive, Input } from '@angular/core';

import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';

import { IScrollable } from './interface';

/**
 * Sends an event when the directive's element is scrolled. Registers itself with the
 * ScrollDispatcher service to include itself as part of its collection of scrolling events that it
 * can be listened to through the service.
 */
@Directive({
  selector: '[rtScrollable], rt-scrollable',
  exportAs: 'rtScrollable',
  host: {
    '[style.overflow-x]': 'suppressScrollX && "hidden"',
  },
})
export class ScrollableDirective extends CdkScrollable implements IScrollable {
  @Input('rtScrollableSuppressScrollX') public suppressScrollX: boolean = false;

  public get top$(): Observable<Event> {
    return this.elementScrolled().pipe(
      filter((evt: Event) => (<HTMLElement>evt.target).scrollTop === 0),
    );
  }

  public get intermediate$(): Observable<Event> {
    return this.elementScrolled().pipe(
      filter(event => {
        const target = <HTMLElement>event.target;
        return (
          target.scrollTop !== 0 && target.scrollHeight - target.scrollTop !== target.clientHeight
        );
      }),
    );
  }

  public get bottom$(): Observable<Event> {
    return this.elementScrolled().pipe(
      filter(event => {
        const target = <HTMLElement>event.target;
        return (
          target.scrollTop !== 0 && target.scrollHeight - target.scrollTop === target.clientHeight
        );
      }),
    );
  }

  public below$(limit: number): Observable<Event> {
    return this.elementScrolled().pipe(
      filter((evt: Event) => (<HTMLElement>evt.target).scrollTop > limit),
    );
  }

  public above$(limit: number): Observable<Event> {
    return this.elementScrolled().pipe(
      filter((evt: Event) => (<HTMLElement>evt.target).scrollTop < limit),
    );
  }

  public get x$(): Observable<number> {
    return this.elementScrolled().pipe(map(evt => (<HTMLElement>evt.target).scrollLeft));
  }

  public get y$(): Observable<number> {
    return this.elementScrolled().pipe(map(evt => (<HTMLElement>evt.target).scrollTop));
  }
}
